import { PERSON_CD_ATTENDEE_MA, PERSON_CD_ATTENDEE_RN } from ".";

export const ROLE_CD_MA = 'ATTENDEEROLE_MA';
export const ROLE_CD_RN = 'ATTENDEEROLE_RN';

export const ATTENDEE_ROLE_PERSON_CD_MAP = {
  [ROLE_CD_MA]: PERSON_CD_ATTENDEE_MA,
  [ROLE_CD_RN]: PERSON_CD_ATTENDEE_RN
};
